export const Select = {
  variants: {
    outline: {
      field: {
        borderColor: "gray.300",
      },
    },
  },
  sizes: {
    sm: {
      field: {
        borderRadius: "md",
      },
    },
    lg: {
      field: { fontSize: "md", borderRadius: "lg" },
    },
  },
  defaultProps: {
    size: "lg",
    focusBorderColor: "brand",
  },
};
